/* eslint-disable no-unused-expressions */
import React, { useEffect } from 'react';
import AUX from '../../../hoc/Aux_';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { getShareReportPublic } from '../../../redux/MainAction';
import { MDBDataTable } from 'mdbreact';

const getDayOfWeek = (date) => {
  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const dateObj = new Date(date);
  const dayIndex = dateObj.getDay();
  return daysOfWeek[dayIndex];
};
const TrackedSharingReport = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const share = useSelector((state) => state.Webtracker.shareReportPublic);
  console.log('share', share);

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    var data = {
      token: param?.token,
    };
    dispatch(getShareReportPublic(data));
  };

  console.log('share', share);

  const convertTimeToHM = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${hours}h : ${minutes}m`;
  };

  const data = {
    columns: [
      { label: 'Member', field: 'userName' },
      { label: 'Project', field: 'ProjectName' },
      { label: 'Mon', field: 'mo' },
      { label: 'Tue', field: 'tu' },
      { label: 'Wed', field: 'we' },
      { label: 'Thu', field: 'th' },
      { label: 'Fri', field: 'fr' },
      { label: 'Sat', field: 'sat' },
      { label: 'Sun', field: 'sun' },
      { label: 'Total', field: 'tt' },
    ],
    rows:
      share?.length > 0
        ? share?.map((Item) => {
            const totalTimeInSeconds =
              Item?.dates?.reduce((acc, date) => acc + date.totalTime, 0) || 0;
            const formattedTime = convertTimeToHM(totalTimeInSeconds);

            const daysData = {
              mo: 'N/A',
              tu: 'N/A',
              we: 'N/A',
              th: 'N/A',
              fr: 'N/A',
              sat: 'N/A',
              sun: 'N/A',
            };

            Item?.dates?.forEach((dateItem) => {
              const dayOfWeek = getDayOfWeek(dateItem.date);
              const formattedDayTime = convertTimeToHM(dateItem.totalTime);

              if (dayOfWeek === 'Monday') daysData.mo = formattedDayTime;
              if (dayOfWeek === 'Tuesday') daysData.tu = formattedDayTime;
              if (dayOfWeek === 'Wednesday') daysData.we = formattedDayTime;
              if (dayOfWeek === 'Thursday') daysData.th = formattedDayTime;
              if (dayOfWeek === 'Friday') daysData.fr = formattedDayTime;
              if (dayOfWeek === 'Saturday') daysData.sat = formattedDayTime;
              if (dayOfWeek === 'Sunday') daysData.sun = formattedDayTime;
            });

            return {
              userName: `${Item?.user?.firstName || ''} ${Item?.user?.lastName || ''}`,
              ProjectName: Item?.project?.name || 'N/A',
              ...daysData,
              tt: formattedTime,
            };
          })
        : [],
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card ">
                <div className="card-body">
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: '20px', margin: '10px 0px' }}
                  >
                    <h5 className="text-muted">Tracked Hours Report</h5>
                    {/* <div
                      className="d-flex align-items-center font-14"
                      style={{ gap: '10px' }}
                    >
                      From
                      <input
                        type="date"
                        className="form-control font-14"
                        disabled
                      />
                      to
                      <input
                        type="date"
                        disabled
                        className="form-control font-14"
                      />
                    </div> */}
                  </div>
                  <MDBDataTable
                    bordered
                    hover
                    data={data}
                    paging={false}
                    searching={false}
                    noBottomColumns
                    noRecordsFoundLabel="No record found"
                    style={{ textAlign: 'center' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default TrackedSharingReport;
